import { render, staticRenderFns } from "./Seletor.vue?vue&type=template&id=47c18153"
import script from "./Seletor.vue?vue&type=script&lang=js"
export * from "./Seletor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports